import { ButtonPrimary, ButtonStatus, ButtonTertiary } from "@nova/component-btn"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { InputOutlined } from "@nova/ds-component-input"
import { HTMLAttributes, useCallback, useEffect, useRef, useState } from "react"
import { usePilotTrackingConnectedAccountMutation } from "../usePilotTrackingConnectedAccountMutation"
import { BeforeYouSyncModalProps } from "../../sync/BeforeYouSyncModal"

export const ConnectedAccountCreateAutelModal = ({
    confirm,
    cancel,
    isPerformingAsyncConfirmCallback: _,
    isPerformingAsyncCancelCallback: __,
    onCreate,
    ...rest
}: BeforeYouSyncModalProps & {
    onCreate: (email: string, password: string) => Promise<void>
} & HTMLAttributes<HTMLDivElement>) => {
    const emailRef = useRef<HTMLInputElement>(null)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    useEffect(() => {
        emailRef.current?.focus()
    }, [])

    const { trigger, isLoading } = usePilotTrackingConnectedAccountMutation({
        key: "autel-connection",
        confirm,
        cancel,
        mutate: useCallback(async () => {
            await onCreate(email, password)
        }, [email, password, onCreate]),
    })

    return (
        <HighPriorityNovaModalContainer
            {...rest}
            title="Add an Autel Account"
            closeModal={cancel}
            className="w-[28rem]"
            bottomBar={
                <div className="flex ml-auto gap-2">
                    <ButtonTertiary title="Cancel" className="ml-auto" onClick={cancel} />
                    <ButtonPrimary
                        title="Add Account"
                        onClick={() => trigger()}
                        status={isLoading ? ButtonStatus.Loading : ButtonStatus.Normal}
                        disabled={isLoading}
                    />
                </div>
            }
        >
            <form
                className="flex flex-col gap-4 mt-4"
                onSubmit={(e) => {
                    e.preventDefault()
                    trigger()
                }}
            >
                <InputOutlined
                    ref={emailRef}
                    placeholder="me@example.com"
                    label="Autel Email"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                {/* This uses type:text and WebkitTextSecurity to prevent the browser
                from prompting the user to save the credentials. */}
                <InputOutlined
                    placeholder="Password"
                    label="Autel Password"
                    type="text"
                    autoComplete="off"
                    style={{ WebkitTextSecurity: "disc" } as React.CSSProperties}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit" className="hidden" aria-hidden="true" />
            </form>
        </HighPriorityNovaModalContainer>
    )
}
